import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface IHttpService {
  get(url: string, headers: any): Observable<IResponseInfo>;

  post(url: string, body: any, headers: any): Observable<IResponseInfo>;

  put(url: string, body: any, headers: any): Observable<IResponseInfo>;

  delete(url: string, headers: any): Observable<IResponseInfo>;
}

export type RequestMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';
export type ResponseContentType = 'arraybuffer' | 'blob' | 'json' | 'text';

export interface IRequest {
  method: RequestMethod;
  url: string;
  body?: any;
  params?: any;
  headers: any;
  storeRequest?: boolean;
  responseType?: ResponseContentType;
  timeout?: number;
}

export interface IResponseInfo {
  headers: HttpHeaders;
  body: any;
  status: number;
}

// Response error format from backend API
export interface IResponseError {
  code: number;
  description: string;
  metadata: any;
}

export const REQUEST_TIMEOUT = 30000;
export const LONG_REQUEST_TIMEOUT = 90000;
export const CONTENT_TYPE_HEADER = 'Content-Type';
